import request from "./axios";

export function submitForm(data) {
  return request({
    url: "/api/Temp/Signin2",
    method: "post",
    data,
  });
}
export function getSignTotal() {
  return request({
    url: "/api/Temp/GetTotal2",
    method: "get",
  });
}
